export default "__VITE_ASSET__BJgEf0yd__"